import _ from "lodash";
import { useState, useEffect } from "react";
import { template as tmpl } from "./template";
import { toast } from "@/modules/toast";
import { NOTIFICATION_TYPE } from "@/config/constants";

const ConfirmOTP = ({ userInfo, method, onSubmitConfirmOTP, onSendOTPAgain, expiredDate, loading, errors }) => {
	const [countDown, setCountDown] = useState(0);
	const [otp, setOtp] = useState("");

	useEffect(() => {
		if (expiredDate) {
			const countDownDate = new Date(expiredDate).getTime();
			const interval = setInterval(() => {
				setCountDown(countDownDate - new Date().getTime());
			}, 1000);

			return () => clearInterval(interval);
		}
	}, [expiredDate]);

	const onConfirmOTP = async () => {
		if (loading) return;

		if (!otp) {
			toast({
				type: NOTIFICATION_TYPE.ERROR,
				description: "Please Enter OTP.",
			});
			return;
		}

		onSubmitConfirmOTP(otp);
	};

	const handleChangeOtp = (otp) => {
		setOtp(otp);
	};

	const initProps = {
		userInfo: userInfo,
		method: method,
		errors: errors,
		otp: otp,
		setOtp: setOtp,
		countDown,
		handleChangeOtp: handleChangeOtp,
		sendCodeAgain: onSendOTPAgain,
		onConfirmOTP,
		loading,
	};
	return tmpl && tmpl({ ...initProps });
};

export default ConfirmOTP;
